//
// locale_oc.js
// automatically generated by generateLocalePacks.js
//
import messages from '../../app/javascript/mastodon/locales/oc.json';
import localeData from "../../app/javascript/mastodon/locales/locale-data/oc.js";
import { setLocale } from '../../app/javascript/mastodon/locales';
setLocale({messages, localeData});



// WEBPACK FOOTER //
// ./tmp/packs/locale_oc.js